const setupFooterCollapse = () => {
    const footerElem = document.querySelector('footer')
    if (!footerElem) {
        return
    }

    const footerInfo = footerElem.querySelector('.footer-info')
    if (!footerInfo) {
        return
    }
    footerInfo.setAttribute('id', 'parent-footer')

    const isDesktop = window.innerWidth > 768
    const columns = footerInfo.querySelectorAll('div.footer-collapse')

    columns.forEach((column, index) => {
        const header = column.querySelector('header')
        const aside = column.querySelector('aside')

        if (!header || !aside) return

        if (isDesktop) {
            // Remove all added attributes and classes
            header.classList.remove('collapsed')
            ;['id', 'data-bs-toggle', 'aria-expanded', 'data-bs-target'].forEach(attr =>
                header.removeAttribute(attr),
            )
            aside.classList.remove('collapse')
            aside.removeAttribute('id')
            aside.removeAttribute('data-bs-parent')
        } else {
            // Adding attributes and classes
            const collapseNum = index + 1
            header.classList.add('collapsed')
            Object.entries({
                id: `trigger-num${collapseNum}`,
                'data-bs-toggle': 'collapse',
                'aria-expanded': false,
                'data-bs-target': `#num${collapseNum}`,
            }).forEach(([attr, value]) => header.setAttribute(attr, value))

            aside.classList.add('collapse')
            aside.setAttribute('id', `num${collapseNum}`)
            aside.setAttribute('data-bs-parent', '#parent-footer')
        }
    })
}

window.addEventListener('resize', setupFooterCollapse)

document.addEventListener('DOMContentLoaded', setupFooterCollapse)
